import type { Dictionary } from '@emobg/web-utils';

export interface RouteItem {
  path: string;
  name: string;
}

export const ROUTES: Dictionary<RouteItem> = {
  BASE: {
    path: '/',
    name: 'onlinecheckin',
  },
  VALIDATE_BOOKING: {
    path: 'validate-booking',
    name: 'validateBooking',
  },
  CONFIRM_BOOKING: {
    path: 'confirm-booking',
    name: 'confirmBooking',
  },
  BOOKING_NOT_FOUND: {
    path: 'booking-not-found',
    name: 'bookingNotFound',
  },
  WELCOME: {
    path: 'welcome',
    name: 'welcome',
  },
  SELECT_COUNTRY: {
    path: 'select-country',
    name: 'selectCountry',
  },
  REQUIRED_CLIENT_DATA: {
    path: 'required-client-data',
    name: 'requiredClientData',
  },
  VALIDATE_DOCUMENTS: {
    path: 'doc-scan',
    name: 'validateDocuments',
  },
  UPDATE_ADDRESS: {
    path: 'update-client-address',
    name: 'updateAddress',
  },
  SUMMARY: {
    path: 'summary',
    name: 'summary',
  },
} as const;

export const ROUTES_WITH_MOBILE_HEADER = [ROUTES.WELCOME.name, ROUTES.SUMMARY.name, ROUTES.CONFIRM_BOOKING.name, ROUTES.BOOKING_NOT_FOUND.name] as const;
